import React from 'react';
import Styles from './PartiuGpChances.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import CustomEmblaCarouselHome24 from '@/components/organisms/CustomEmblaCarouselHome24';
import { useLayout } from '@/utils/useLayout';

const SIMULAR_URL =
  'https://www.cliente.santanderfinanciamentos.com.br/originacaocliente/?int_source=portalSF&int_medium=partiu-gp-da-inglaterra:chances&int_campaign=simular-financiamento';

const cards = [
  {
    badge: '+1',
    titulo: 'Seguro prestamista',
    texto: 'Contratado junto ao contrato de financiamento',
  },
  {
    badge: '+1',
    titulo: 'Conta ativa Santander',
    texto: 'Ser correntista ativo durante o período de participação',
  },
  {
    badge: null,
    titulo: 'Mais números da sorte',
    texto: 'Com os números adicionais, você acumula até 3 chances para concorrer',
  },
];

function Card({ card, className }) {
  return (
    <div className={`card ${className || ''}`}>
      {card.badge && <span className="card-badge">{card.badge}</span>}
      <h3 className="card-titulo">{card.titulo}</h3>
      <p className="card-texto">{card.texto}</p>
    </div>
  );
}

function PartiuGpChances() {
  const { width } = useLayout();
  const isDesktop = width >= 992;

  return (
    <section id="partiu-gp-chances">
      <ContainerHome24>
        <p className="eyebrow">Multiplique suas chances</p>
        <h2 className="titulo">Ganhe mais números da sorte</h2>

        {isDesktop ? (
          <div className="cards">
            {cards.map((card, index) => (
              <React.Fragment key={card.titulo}>
                {index === 1 && <span className="plus">e</span>}
                {index === 2 && <span className="plus">=</span>}
                <Card card={card} />
              </React.Fragment>
            ))}
          </div>
        ) : (
          <div className="carrossel">
            <CustomEmblaCarouselHome24>
              {({ className }) =>
                cards.map((card) => <Card card={card} className={className} key={card.titulo} />)
              }
            </CustomEmblaCarouselHome24>
          </div>
        )}
        <p className="disclaimer">
          <b>Importante:</b> esses dois Números da Sorte extras são concedidos uma única vez durante
          toda a promoção, e não a cada financiamento contratado.
        </p>
        <a href={SIMULAR_URL} target="_blank" rel="noopener" className="cta">
          Simular agora
        </a>
      </ContainerHome24>
      <style jsx>{Styles}</style>
    </section>
  );
}

export default PartiuGpChances;
